// This file exports various Algolia-based recommendation components for easy access.
// Each component handles a different recommendation model like Trending, Related, or Bought Together.
// It also exports the `AlgoliaRecommendationProvider` to set up the search context.

export { default as BoughtTogetherItems } from './BoughtTogetherRecommendation';
export { default as RelatedProductsItems } from './RelatedProductsRecommendation';
export { default as TrendingItems } from './TrendingItemsRecommendation';
export { default as TrendingFacetsItems } from './TrendingFacetsRecommendation';
export { default as LookingSimilarItems } from './LookingSimilarRecommendation';
export { default as AlgoliaRecommendationProvider } from './AlgoliaRecommendationProvider';
